// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';

// Component Files
import { TellerOnlineScheduledPaymentDetailsComponent } from './scheduled-payment-details.component';

@NgModule({
    declarations: [TellerOnlineScheduledPaymentDetailsComponent],
    imports: [
        CommonModule,
        MatDividerModule,
        MatTooltipModule,
        MatListModule
    ],
    exports: [TellerOnlineScheduledPaymentDetailsComponent]
})
export class TellerOnlineScheduledPaymentDetailsModule { }
